import { useEffect, forwardRef } from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import {
  Badge,
  CloseButton,
  Inline,
  Heading,
  Hidden,
  Visible,
  Stack,
  Text
} from '@leroy-merlin-br/backyard-react-ui'

import { error as errorMessage } from 'scripts/utils/message'

import { Drawer } from 'reactShared/components/Drawer'

import { SellersListItem } from 'catalog/pages/Product/containers/Buybox/components/SellersListItem'
import { Actions as UiActions } from 'catalog/redux/ui'

import * as S from './styled'

const SellersList = forwardRef(({
  productId,
  productName,
  productImg,
  closeDrawer
}, ref) => {
  // TODO: PEGAR productId, productName, productImg, productBrand, category pelo redux

  const { skus, isRequest, error } = useSelector(
    state => state.skus,
    shallowEqual
  )
  const isDrawerOpen = useSelector(state => state.ui.sellersDrawerOpen)

  const dispatch = useDispatch()

  useEffect(() => {
    if (error.message) {
      errorMessage(error.message)
      closeDrawer()
    }
  }, [error.message, closeDrawer])

  const pickupInStoreClick = () => {
    closeDrawer()
    dispatch(UiActions.openStockInfoDrawer())
  }

  const renderSkusList = skus => {
    return skus?.map(({ id, shop, price, purchaseButtons, limitQuantity }) => (
      <SellersListItem
        key={id}
        productId={productId}
        id={id}
        shop={shop}
        price={price}
        purchaseButtons={purchaseButtons}
        limitQuantity={limitQuantity}
        pickupInStoreClick={pickupInStoreClick}
        closeDrawer={closeDrawer}
      />
    ))
  }

  return (
    <Drawer
      ref={ref}
      isOpen={!isRequest && isDrawerOpen}
      overlayClick={closeDrawer}
      className="sellers-list"
    >
      <S.Wrapper>
        <Stack spacing="mega">
          <Inline spacing="bit" justify="left" align="center" noWrap>
            <CloseButton label="Fechar" onClick={closeDrawer} />

            <S.Title>
              Compare os preços entre nossas lojas parceiras
            </S.Title>
          </Inline>

          <S.ProductContainer>
            <Inline spacing="giga" justify="left" align="top" noWrap>
              <S.ProductImage alt={productName} src={productImg} />

              <Stack spacing="byte">
                <div>
                  <Visible untilKilo kilo>
                    <Heading as="h3" size="kilo" noMargin>
                      {productName}
                    </Heading>
                  </Visible>

                  <Hidden untilKilo kilo>
                    <Heading as="h3" size="tera" noMargin>
                      {productName}
                    </Heading>
                  </Hidden>
                </div>

                <Badge color="gray">Cód. {productId}</Badge>
              </Stack>
            </Inline>
          </S.ProductContainer>

          <Stack spacing="byte">
            <Hidden untilKilo kilo>
              <S.SkusHeader>
                <S.SkusHeaderTitle>
                  <Text as="div" size="giga" noMargin bold>
                    Lojas
                  </Text>
                </S.SkusHeaderTitle>

                <S.SkusHeaderTitle>
                  <Text as="div" size="giga" noMargin bold>
                    Preço do produto
                  </Text>
                </S.SkusHeaderTitle>

                <S.SkusHeaderTitle>
                  <Text as="div" size="giga" noMargin bold>
                    Opções de compra
                  </Text>
                </S.SkusHeaderTitle>
              </S.SkusHeader>
            </Hidden>

            {renderSkusList(skus)}
          </Stack>
        </Stack>
      </S.Wrapper>
    </Drawer>
  )
})

SellersList.propTypes = {
  productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  productName: PropTypes.string.isRequired,
  productImg: PropTypes.string.isRequired,
  closeDrawer: PropTypes.func.isRequired
}

export default SellersList
